import { callMeAjax } from "../../../../../../../../public/rubberduck/dist/lib/rubberduck/callMeAjax.build";
import { backgroundSetter } from "../../../../../../../../public/rubberduck/dist/lib/rubberduck/backgroundSetter/backgroundSetter.js";

export function EventCalendarHandler({categories_input = 'radio', tags_input = 'checkbox'} = {}) {
    this.events = [];
    this._current_date = '';
    this._previous_month = '';
    this._current_month = '';

    this._categories_input = categories_input;
    this._tags_input = tags_input;

    this.init = function () {
        window.$body.on('click', '.months_current', function (e) {
            e.stopPropagation();

            if (!$(this).hasClass('active')) {
                $('.months_list').stop().slideDown();
                $('.months_current').addClass('active');
            } else {
                $('.months_list').stop().slideUp();
                $('.months_current').removeClass('active');
            }
        });

        window.$body.on('click', '.calendar .next', function (e) {
            $('.months_list li.active').next().trigger('click');
        });

        window.$body.on('click', '.calendar .prev', function (e) {
            $('.months_list li.active').prev().trigger('click');
        });

        window.$body.on('click', '.months_list li', function (e) {
            let target = $(e.currentTarget);
            let month = target.data('month');
            let year = target.data('year');

            e.stopPropagation();
            this.changeCurrentMonth(month, year);

            let data = new FormData($("#filters")[0]);
            let active_day = $('#month_container .day.day_date.active');
            if (active_day.length > 0) {
                data.append('active_day', active_day.data('timestamp'));
            }
            data.append('month', month);
            data.append('year', year);
            this._request('/fetch-front-end-calendar-month', data);
        }.bind(this));

        window.$body.on('click', '.calendar .reset_calendar', function (e) {
            let now = new Date();
            let month = now.getMonth() + 1;
            let year = now.getFullYear();

            e.stopPropagation();
            this.changeCurrentMonth(month, year);

            let data = new FormData();
            $('#filters input[type="hidden"]').each(function(index, input) {
                data.append(input.name, input.value);
            });
            $('#month_container .day.day_date.active').removeClass('active');
            $('#filters input[type="radio"], #filters input[type="checkbox"]').each(function(index, input) {
                $(input).attr('checked', false);
                $(input).prop('checked', false);
                $(input).closest('.filter_sub').removeClass('active');
            });
            this.triggerInputCategory('');
            this.triggerInputTag(['']);
            data.append('month', month);
            data.append('year', year);
            this._request('/fetch-front-end-calendar-month', data);
        }.bind(this));
    

        window.$body.on('click', function () {
            if ($('.months_current').hasClass('active')) {
                $('.months_list').slideUp();
                $('.months_current').removeClass('active');
            }
        });

        window.$body.on('click', '.day_date', function (e) {
            let target = $(e.currentTarget);
            let timestamp = target.data('timestamp');
            $('.calendar').attr('data-timestamp', timestamp);
            $('.calendar .day').removeClass('active');
            target.addClass('active');
            if (timestamp != '' && timestamp != undefined) {
                data = new FormData($("#filters")[0]);
                data.append('timestamp', timestamp);
                this._request('/fetch-front-end-event-by-date', data);
            }
        }.bind(this));

        this.initEventByType();

        window.$body.on('change', '.calendar_filters input, .calendar_filters select', function () {
            $('.months_list li.active').trigger('click');
        });
        
        if ($('#place_events_here').hasClass('no_trigger') === false) {
            this.setFromUrlParams(new URLSearchParams(window.location.search)); 
        }
    }

    this.changeCurrentMonth = (month, year) => {
        $('.months_list li.active').removeClass('active');
        let current_month = $('.months_list li[data-month="' + month + '"][data-year="' + year + '"]');
        $('.months_list li.active').removeClass('active');
        current_month.addClass('active');
        $('.months_current').html(current_month.html());

        this._previous_month = $('.calendar').attr('data-month');
        this._current_month = month;
        $('.calendar').attr('data-month', this._current_month);
    }

    this.changeCurrentDate = (current_date) => {
        this._current_date = current_date;
    }

    this.setFromUrlParams = (url_params) => {
        if (document.getElementById('month_container') != null) {
            let timestamp, month, year, search = null;
            if (url_params.has('day') && url_params.has('month') && url_params.has('year')) {
                if (
                    url_params.get('month') == $('.months_list .active').attr('data-month') &&
                    url_params.get('year') == $('.months_list .active').attr('data-year')
                ) {
                    let date = new Date(url_params.get('year'), (url_params.get('month') - 1), url_params.get('day'));
                    timestamp = date.getTime() / 1000;
                    $('.day.day_date[data-timestamp="' + timestamp + '"]').addClass('active');
                    $('.calendar').attr('data-timestamp', timestamp);
                }
            }
    
            if (url_params.has('month') && url_params.has('year')) {
                month = url_params.get('month');
                this.changeCurrentMonth(url_params.get('month'), url_params.get('year'));
            }
            if (url_params.has('year')) {
                year = url_params.get('year');
            }

            if (url_params.has('search')) {
                search = url_params.get('search');
            }
    
            if (url_params.has('category')) {
                this.triggerInputCategory(url_params.get('category'));
            } else {
                this.triggerInputCategory('');
            }
            if (url_params.has('tag')) {
                this.triggerInputTag(url_params.getAll('tag'));
            } else {
                this.triggerInputTag(['']);
            }
    
            let data = new FormData($("#filters")[0]);
            if (month != null) {
                data.append('month', month);
            }
            if (year != null) {
                data.append('year', year);
            }
            let active_day = $('#month_container .day.day_date.active');
            if (active_day.length > 0 ) {
                data.append('active_day', active_day.data('timestamp'));
            }
            if (timestamp != null) {
                data.append('timestamp', timestamp);
            }
            if (timestamp == null && month == null && year == null) {
                let date = new Date();
                month = date.getMonth() + 1;
                year = date.getFullYear();
                data.append('month', month);
                data.append('year', year);
            }
            this._request('/fetch-front-end-calendar-month', data);
        }
    }

    this._addCalendarFiltersToUrl = () => {
        let params = [];
        let day = $('#month_container .day_date.active .day_number').text();
        if (day != '' && day != undefined) {
            params.push('day=' + day);
        }
        let month = $('.months_list li.active').attr('data-month');
        if (month != '' && month != undefined) {
            params.push('month=' + month);
        }
        let year = $('.months_list li.active').attr('data-year');
        if (year != '' && year != undefined) {
            params.push('year=' + year);
        }
        let search = $('.calendar_filters .filter_sub [name="filters[search]"]').val();
        if (search != '' && search != undefined) {
            params.push('search=' + search);
        }
        let category = $('.calendar_filters .filter_sub [name="filters[categ]"]' + this._getSelector(this._categories_input)).val();
        if (category != '' && category != undefined) {
            params.push('category=' + category);
        }
        let tags = $('.calendar_filters .filter_sub [name="filters[tag_id][]"]' + this._getSelector(this._tags_input));
        if (tags.length > 0) {
            tags.each((index, tag) => {
                if (tag.value != '' && tag.value != null) {
                    params.push('tag=' + tag.value);
                }
            });
        }
        let url = window.location.pathname + '?' + params.join('&');
        if (Object.keys(params).length > 0) {
            window.history.pushState(
                {
                    url: url,
                    random: Math.random(),
                    source: 'swup'
                },
                document.getElementsByTagName('title')[0].innerText,
                url
            );
        }
    }

    this._request = function(action, formData) {

        formData.getAll('filters[tag_id][]').forEach((value) => {
            if(value == '') {
                formData.delete('filters[tag_id][]');
                return;
            }
        });

        return callMeAjax(action, formData).then((data) => {
            this._handleRequestResponse(data);
        });
    }

    this._handleRequestResponse = function(data) {
        if (data.events) {
            $('#place_events_here').html(data.events);
        }
        if (data.date) {
            $('.current_date_here').html(data.date);
            this.changeCurrentDate(data.date);
            if ($('#anchor').length > 0) {
                $('html, body').animate({
                    scrollTop: $('#anchor').offset().top
                }, 700);
            }
        }
        if (data.month) {
            $('#month_container').replaceWith(data.month);
        }
        if ((this._previous_month !== '' || this._current_month) !== '' && (this._previous_month != this._current_month)) {
            $('.calendar').attr('data-timestamp', '');
        } else {
            let current = $('.calendar').attr('data-timestamp');
            if (current != undefined && current != '' && $('.day.day_date[data-timestamp="' + current + '"]').length > 0) {
                $('.day.day_date[data-timestamp="' + current + '"]').addClass('active');
            }
        }
        bgSetter = new backgroundSetter();
        bgSetter.init();
        this._addCalendarFiltersToUrl();
    }

    this.initEventByType = () => {
        switch (this._categories_input) {
            case "radio":
                // empty
                break;
            case "checkbox":
                window.$body.on('click', 'input[name="filters[categ][]"]', () => {
                    if ($('input[name="filters[categ][]"]:checked').length > 0) {
                        $('input[name="filters[categ]"]').removeAttr('checked');
                        $('input[name="filters[categ]"]').prop('checked', false);
                    } else {
                        $('input[name="filters[categ]"]').attr('checked', true);
                        $('input[name="filters[categ]"]').prop('checked', true);
                    }
                });
        
                window.$body.on('click', 'input[name="filters[categ]"]', () => {
                    if ($('input[name="filters[categ][]"]:checked').length) {
                        $('input[name="filters[categ][]"]').removeAttr('checked');
                        $('input[name="filters[categ][]"]').prop('checked', false);
                    } else {
                        $('input[name="filters[categ]"]').attr('checked', true);
                        $('input[name="filters[categ]"]').prop('checked', true);
                    }
                });
                break;
            case "select":
                break;
        }
        switch (this._tags_input) {
            case "radio":
                // empty
                break;
            case "checkbox":
                window.$body.on('click', 'input[name="filters[tag_id][]"]', () => {
                    if ($('input[name="filters[tag_id][]"]:checked').length > 0) {
                        $('input[name="filters[tag_id]"]').removeAttr('checked');
                        $('input[name="filters[tag_id]"]').prop('checked', false);
                    } else {
                        $('input[name="filters[tag_id]"]').attr('checked', true);
                        $('input[name="filters[tag_id]"]').prop('checked', true);
                    }
                });
        
                window.$body.on('click', 'input[name="filters[tag_id]"]', () => {
                    if ($('input[name="filters[tag_id][]"]:checked').length) {
                        $('input[name="filters[tag_id][]"]').removeAttr('checked');
                        $('input[name="filters[tag_id][]"]').prop('checked', false);
                    } else {
                        $('input[name="filters[tag_id]"]').attr('checked', true);
                        $('input[name="filters[tag_id]"]').prop('checked', true);
                    }
                });
                break;
            case "select":
                break;
        }
    }

    this.triggerInputCategory = (category_id) => {
        switch (this._categories_input) {
            case 'radio':
                let input = $('input[name="filters[categ]"][value="' + category_id + '"]');
                input.attr('checked', true);
                input.prop('checked', true);
                input.parents('.filter_sub').addClass('active');
                break;
            case 'checkbox':
                if (category_id === '') {
                    let input = $('input[name="filters[categ]"][value=""]');
                    input.attr('checked', true);
                    input.prop('checked', true);
                    input.parents('.filter_sub').addClass('active');
                    break;
                } else {
                    let input = $('input[name="filters[categ][]"][value="' + category_id + '"]');
                    input.attr('checked', true);
                    input.prop('checked', true);
                    input.parents('.filter_sub').addClass('active');
                }
                break;
            case 'select':
                let select = $('select[name="filters[categ]"][value="' + category_id + '"]');
                select.attr('selected', true);
                select.prop('selected', true);
                select.addClass('active');
                break;
    }

    this.triggerInputTag = (tags) => {
        switch (this._tags_input) {
            case 'radio':
            case 'checkbox':
                tags.forEach((tag) => {
                    if (tag === '') {
                        let input = $('input[name="filters[tag_id]"][value=""]');
                        input.attr('checked', true);
                        input.prop('checked', true);
                        input.parents('.filter_sub').addClass('active');
                    } else {
                        let input = $('input[name="filters[tag_id][]"][value="' + tag + '"]');
                        input.attr('checked', true);
                        input.prop('checked', true);
                        input.parents('.filter_sub').addClass('active');    
                    }
                });
                break;
            case 'select':
                break;
            }
        }
    }

    this._getSelector = (input_type) => {
        switch (input_type) {
            case 'checkbox':
            case 'radio':
                return ':checked';
            case 'select':
                return ' option:selected';
        }
    }
}
